"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutPoint = void 0;
var tslib_1 = require("tslib");
var point_1 = require("@devexpress/utils/lib/geometry/point");
var LayoutPoint = (function (_super) {
    tslib_1.__extends(LayoutPoint, _super);
    function LayoutPoint(pageIndex, pageX, pageY) {
        var _this = _super.call(this, pageX, pageY) || this;
        _this.pageIndex = pageIndex;
        return _this;
    }
    LayoutPoint.prototype.isEmpty = function () {
        return this.pageIndex == -1;
    };
    LayoutPoint.Empty = function () {
        return new LayoutPoint(-1, -1, -1);
    };
    LayoutPoint.prototype.clone = function () {
        return new LayoutPoint(this.pageIndex, this.x, this.y);
    };
    Object.defineProperty(LayoutPoint.prototype, "point", {
        get: function () {
            return new point_1.Point(this.x, this.y);
        },
        enumerable: false,
        configurable: true
    });
    return LayoutPoint;
}(point_1.Point));
exports.LayoutPoint = LayoutPoint;
